<template>
  <RouteLoader />
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import RouteLoader from "@/components/shared/RouteLoader.vue";
import { empilharModaisBs5 } from "@/utils/empilharModaisBs5";

onMounted(empilharModaisBs5);
</script>

<style>
/* SweetAlert2 (ConfirmModal/RequestModal/Toast) tem de aparecer sempre acima
   de qualquer modal bs5, mesmo quando disparado a partir de um modal já
   aberto (ex.: POS, onde vários modais ficam empilhados).
   O próprio SweetAlert2 já força `body.swal2-shown:not(.swal2-no-backdrop,
   .swal2-toast-shown) .swal2-container { position: static !important }`
   (para lidar com dialogs empilhados) — position:static ignora z-index, e
   essa regra tem especificidade mais alta do que `.swal2-container` sozinho,
   por isso um simples z-index não chegava. Aqui igualamos/excedemos essa
   especificidade e repomos position:fixed. */
body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)
  .swal2-container,
body.swal2-shown .swal2-container {
  position: fixed !important;
  z-index: 2147483647 !important;
}
</style>
